import { useState, useEffect } from 'react';
import { useToast } from '../ui/Toast';

export function useNetworkStatus(onReconnect) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { showToast } = useToast();

  useEffect(() => {
    function handleOnline() {
      setIsOnline(true);
      showToast('Back online! Re-established connection.', 'success');
      if (onReconnect) {
        onReconnect();
      }
    }

    function handleOffline() {
      setIsOnline(false);
      showToast('Connection lost. You are currently offline.', 'error');
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [showToast, onReconnect]);

  return isOnline;
}
